/*jshint browserify: true */
'use strict';

var translateMousePosForElement = require('./translateMousePosForElement.js');
var translateViewportPositionToPdfPosition = require('./translateViewportPositionToPdfPosition.js');

/**
 * A position on a PDF page.
 * Provides coordinate properties for:
 *   - PDF. Position on the page, note that on a PDF, 0,0 is bottom-right.
 *   - Viewport. Position on the viewport HTML element.
 *   - Client. Position within the browser.
 */
var Position = (function PositionClosure() {
    function Position(pdfX, pdfY, pdfViewport, viewportElement) {
        var clientBounds = viewportElement.getBoundingClientRect();
        this.pdfViewport = pdfViewport;

        Object.defineProperty(this, 'pdfX', {
            get: function () {
                return pdfX;
            },
            set: function (newVal) {
                pdfX = newVal;
            }
        });
        Object.defineProperty(this, 'pdfY', {
            get: function () {
                return pdfY;
            },
            set: function (newVal) {
                pdfY = newVal;
            }
        });

        Object.defineProperty(this, 'clientX', {
            get: function () {
                return this.viewportX + clientBounds.left;
            }
        });
        Object.defineProperty(this, 'clientY', {
            get: function () {
                return this.viewportY + clientBounds.top;
            }
        });

        Object.defineProperty(this, 'viewportX', {
            get: function () {
                return this.pdfX * this.pdfViewport.scale;
            }
        });
        Object.defineProperty(this, 'viewportY', {
            get: function () {
                return this.pdfViewport.height - (this.pdfY * this.pdfViewport.scale);
            }
        });
    }

    /**
     * Create a Position object from a mouse event. I.e. the user has clicked somewhere on the PDF.
     *
     * @param {MouseEvent} mouseEvent - Where the click occurred
     * @param {PageViewport} pdfViewport - A PDF.JS PageViewport object
     * @param {HTMLElement} viewportElement - The element containing the PDF viewport
     */
    Position.fromMouseEvent = function (mouseEvent, pdfViewport, viewportElement) {
        var viewportPosition = translateMousePosForElement(viewportElement, mouseEvent);
        var pdfPosition = translateViewportPositionToPdfPosition(pdfViewport, viewportPosition.x, viewportPosition.y);

        return new Position(pdfPosition.x, pdfPosition.y, pdfViewport, viewportElement);
    };

    return Position;
})();

module.exports = Position;